import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Paper = ({
  rounded,
  shadowed,
  elevation,
  children,
  className: classNameProp,
  ...other
}) => {
  const classes = classNames(
    'campus-paper',
    {
      'campus-paper--rounded': rounded,
      'campus-paper--shadowed': shadowed,
      [`elevation-${elevation}`]: elevation,
    },
    classNameProp
  )

  return (
    <div className={classes} {...other}>
      {children}
      <style jsx>
        {`
          .campus-paper {
            position: relative;
            background-color: #fff;

            &--rounded {
              border-radius: 8px;
            }
            &--shadowed {
              box-shadow: 0 6px 16px 0 rgba(107, 143, 188, 0.1);
            }
          }
        `}
      </style>
    </div>
  )
}

Paper.propTypes = {
  rounded: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  elevation: PropTypes.number,
}

Paper.defaultProps = {
  rounded: true,
}

export default Paper
